import React, { useContext } from 'react';
import { MBTextOverlineBold } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';

interface Props {
  label?: string | null;
}

export function MBBlockLabel({ label }: Props) {
  const colors = useContext(ColorThemeContext);

  return (
    <MBTextOverlineBold color={colors.input.label}>{label?.toUpperCase() ?? ''}</MBTextOverlineBold>
  );
}
